class PriceRangeSlider extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('.price-slider');
    this.minRange = this.querySelector('.price-slider__range--min');
    this.maxRange = this.querySelector('.price-slider__range--max');
    this.fill = this.querySelector('[data-fill]');
    this.minField = this.querySelector('[data-bound="min"]');
    this.maxField = this.querySelector('[data-bound="max"]');
    this.minOutput = this.querySelector('[data-output="min"]');
    this.maxOutput = this.querySelector('[data-output="max"]');

    if (!this.minRange || !this.maxRange) return;

    this.currency = this.container ? this.container.dataset.currency || '' : '';
    this.rangeMin = Number(this.minRange.min);
    this.rangeMax = Number(this.minRange.max);
    this.step = Number(this.minRange.step) || 1;

    this.onInput = this.onInput.bind(this);
    this.onChange = this.onChange.bind(this);

    [this.minRange, this.maxRange].forEach((element) => {
      element.addEventListener('input', this.onInput);
      element.addEventListener('change', this.onChange);
    });

    this.update();
  }

  onInput(event) {
    event.stopPropagation();

    let minValue = Number(this.minRange.value);
    let maxValue = Number(this.maxRange.value);

    if (minValue > maxValue) {
      if (event.target === this.minRange) {
        this.minRange.value = maxValue;
      } else {
        this.maxRange.value = minValue;
      }
    }

    this.update();
  }

  onChange(event) {
    event.stopPropagation();
    this.syncFields();
    this.minField.dispatchEvent(new Event('input', { bubbles: true }));
  }

  syncFields() {
    const minValue = Number(this.minRange.value);
    const maxValue = Number(this.maxRange.value);
    this.minField.value = minValue > this.rangeMin ? minValue : '';
    this.maxField.value = maxValue < this.rangeMax ? maxValue : '';
  }

  update() {
    const minValue = Number(this.minRange.value);
    const maxValue = Number(this.maxRange.value);
    const span = this.rangeMax - this.rangeMin || 1;
    const minPercent = ((minValue - this.rangeMin) / span) * 100;
    const maxPercent = ((maxValue - this.rangeMin) / span) * 100;

    if (this.fill) {
      this.fill.style.insetInlineStart = `${minPercent}%`;
      this.fill.style.insetInlineEnd = `${100 - maxPercent}%`;
    }

    if (this.minOutput) this.minOutput.textContent = this.format(minValue);
    if (this.maxOutput) this.maxOutput.textContent = this.format(maxValue);

    this.minRange.style.zIndex = minPercent > 90 ? '5' : '3';
  }

  format(value) {
    const grouped = Math.round(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return this.currency ? `${this.currency} ${grouped}` : grouped;
  }
}

if (!customElements.get('price-range-slider')) {
  customElements.define('price-range-slider', PriceRangeSlider);
}
